import { appEnv } from '../lib/env';

export function SubscribedPage() {
  return (
    <div className="main-container" id="subscribe-complete">
      <div className="main-container-top">
        <h2>Email Confirmation Complete</h2>
        <p className="main-text">Your email address has been successfully registered.</p>
      </div>
      <a href={appEnv.logoFrontendUrl} className="btn-link">
        <button className="secondary">
          <span />
          <span>HOME</span>
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
      </a>
    </div>
  );
}
